import { setCookie, getCookie } from './utils/cookies'

$('body').on('click', '.cookies-agree', function (e){
  e.preventDefault()
  setCookie('e-commerce-cookie-accept', 1, 30)
  $('.cookies').fadeOut(300, function (){
    $('.cookies').remove()
  })
})

$('body').on('click', '.cookies-disagree', function (e){
  e.preventDefault()
  $('.cookies').fadeOut(300, function (){
    $('.cookies').remove()
  })
})

if(getCookie('e-commerce-cookie-accept') !== '1'){
  $('.cookies').fadeIn().css('display', 'flex')
}
